import React from 'react'
import Gitalk from 'gitalk'
import md5 from 'blueimp-md5'

import '../style/gitalk.css'

class GitTalk extends React.Component {
	componentDidMount() {
		const gitalk = new Gitalk({
			clientID: '75ea2191c8da60f43dca',
			clientSecret: 'ab7f0489b457f11b193d94d752a01a591c73fcdb',
			repo: 'comments',
			owner: 'naseeihity',
			admin: ['naseeihity'],
			title: this.props.title || 'Kevin',
			id: md5(window.location.pathname),
			distractionFreeMode: false // Facebook-like distraction free modex
		})

		gitalk.render('gitalk-container')
	}

	render() {
		return <div id="gitalk-container" />
	}
}
export default GitTalk
